module.exports = __webpack_public_path__ + "static/img/pitch_grey_wide.f3f2124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_grey_wide.png
// module id = xBif
// module chunks = 94